import { render } from "./SearchBar.vue?vue&type=template&id=e492bc56&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=e492bc56&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e492bc56"],['__file',"src/views/UserManagement/SelfRegistration/components/SearchBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e492bc56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e492bc56', __exports__)) {
    api.reload('e492bc56', __exports__)
  }
  
  module.hot.accept("./SearchBar.vue?vue&type=template&id=e492bc56&scoped=true", () => {
    api.rerender('e492bc56', render)
  })

}


export default __exports__